<!--
 * @Descripttion: 
 * @Version: 1.0
 * @Author: pj
 * @Date: 2022-10-26 14:52:49
 * @LastEditors: pj
 * @LastEditTime: 2022-10-28 11:51:28
-->
<template>
    <div>
        <a-card size="small" title="WS连接客户端IP流量监控明细统计">
        </a-card>
        <a-card size="small">
            <searchE @handleSearch="handleSubmit"></searchE>
            <tableE ref="ipdeatilTableID"></tableE>
        </a-card>
    </div>
</template>
<script>
import tableE from './table'
import searchE from './search'

export default {
    data() {
        return {
            searchP: {
                keyword: '',
            },
        }
    },
    methods: {
        handleSubmit(searchP) {
            this.$refs.ipdeatilTableID.handleSearch(searchP)
        }
    },
    components: {
        tableE,
        searchE,
    },
    mounted() {},
}
</script>
<style scoped>
</style>
